import React from "react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";

import withStyles from "@material-ui/core/styles/withStyles";

import PbButton from "../PbButton";
import PrimaryButton from "../../../../components/Buttons/PrimaryButton";
import CompareIcon from "../../../../images/CompareIcon";
import BaseDialog from "../../../../components/BaseDialog/BaseDialog";
import CustomersNew from "../../../../components/CustomersSelectorProviderNew/CustomersNew";
import {getSubSystemConfigItem, onboardingOnCustomersChange} from "../../../../utils/utils";
import {OnboardingButtonAttributesHelper} from "../../../CustomerDashboardV2/utils";
import {getInvestmentPlatformSelector} from "../../../../utils/redaxSelectors";
import {executeIfPathExist, getInvestmentDynamicPath} from "../../../InvestmentPlatform/utils";

import styles from "../CustomerDepotSelectionModal/styles";



const CustomerSelectionForOnboarding = (props) => {
  const {classes} = props;

  const [open, setOpen] = React.useState(false);

  const onboardings = React.useRef({});

  const onCustomersChange = async (customers) => {
    onboardings.current = await onboardingOnCustomersChange(customers);
  };

  const extraColumns = React.useMemo(() => {
    return [{
      content: [{
        header: '',
        body: {
          content: (customer) => {
            let tooltip;
            let disabled = !!customer.bca_is_company;
            if(OnboardingButtonAttributesHelper.isOnboardingProcessStarted(onboardings.current[customer.id])){
              disabled = true;
              tooltip = 'Es existiert bereits ein offener Depoteröffnungsvorgang.';
            }

            return (
              <PrimaryButton
                icon={<CompareIcon color={'currentColor'} />}
                iconPosition={'right'}
                variant={'text'}
                text={'Portfolio-Builder'}
                disabled={disabled}
                tooltip={tooltip}
                onButtonClick={() => goToTradeDetails(customer)}
              />
            )
          },
          className: 'extraButton',
        }
      }]
    }]
  }, []);

  const goToTradeDetails = async (customer) => {
    const useNewDesign = getSubSystemConfigItem('onboarding', 'use_v2');
    executeIfPathExist(props.investmentPlatform.routes, useNewDesign ? 'RISK_PROFILING_V2' : 'RISK_PROFILING', (path) => {
      let url = `/${getInvestmentDynamicPath()}${path.replace(':customer_id', customer.customer_id)}?auto_portfolio_builder=1`;
      props.history.push(url)
    }, ':customer_id');
  };

  return (
    <>
      <PbButton text={'Depot neu eröffnen'} onClick={() => setOpen(true)} />
      <BaseDialog
        open={open}
        title={"Kundenübersicht"}
        handleClose={() => setOpen(false)}
        customClasses={{dialogContent: classes.dialogContent}}
      >
        <CustomersNew
          extraColumns={extraColumns}
          withHeader={false}
          onCustomersChange={onCustomersChange}
        />
      </BaseDialog>
    </>
  )
};

const mapStateToProps = (state) => ({
  investmentPlatform: getInvestmentPlatformSelector(state),
});

export default withRouter(connect(mapStateToProps)(withStyles(styles)(CustomerSelectionForOnboarding)));